import { render, staticRenderFns } from "./NotasXml.vue?vue&type=template&id=c2cb2f3a&scoped=true&"
import script from "./NotasXml.vue?vue&type=script&lang=js&"
export * from "./NotasXml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cb2f3a",
  null
  
)

export default component.exports